<template>
  <div>
    <v-toolbar flat color="primary" dark>
      <v-toolbar-title>Student Details</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer> </v-spacer>
      <template>
        <v-btn
          dark
          outline
          class="mb-2"
          v-show="!isEditStudentForm"
          @click="back"
          >Back</v-btn
        >
      </template>
    </v-toolbar>

    <!-- #TODO There might be better way to load component after getting data -->
    <!-- https://stackoverflow.com/questions/46890816/vuejs-component-created-wait-for-data-to-load-first -->
    <template>
      <template v-if="!progressBar">
        <student-form
          v-show="isEditStudentForm"
          :isStudentFormEnabled="isEditStudentForm"
          :model="editedModel"
          :dropdowns="dropdowns"
          :batches="batches"
          formContext="edit"
          v-on:studentFormCancelEvent="onFormCancel"
          v-on:studentFormUpdateEvent="onFormSave"
        ></student-form>
      </template>
    </template>

    <v-card v-if="!progressBar" v-show="!isEditStudentForm">
      <v-container fluid grid-list-md>
        <v-card>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-progress-circular
                indeterminate
                color="primary"
                v-show="progressBar"
              ></v-progress-circular>
              <v-expansion-panel popout v-model="panel" expand>
                <v-expansion-panel-content
                  v-for="(section,
                  propertyName,
                  index) in studentDetailSections"
                  :key="index"
                >
                  <template v-slot:header>
                    <div class="headline primary--text">
                      {{ getSectionTitle(propertyName) }} Details
                    </div>
                  </template>
                  <v-card>
                    <v-card-text>
                      <v-list
                        dense
                        v-for="(value, property, sectionIndex) in section"
                        :key="sectionIndex"
                      >
                        <v-avatar size="96" v-if="value == 'ProfileImage'">
                          <img :src="preview" />
                        </v-avatar>
                        <v-list-tile v-if="value != 'ProfileImage'">
                          <v-list-tile-content>
                            <v-container grid-list-md text-xs-center>
                              <v-layout row wrap>
                                <v-flex xs4>
                                  <div class="subheading xs4 text-xs-left">
                                    {{ getLabel(value) }}:
                                  </div>
                                </v-flex>
                                <v-flex xs6>
                                  <div class="body-2 xs6 text-xs-left">
                                    {{ viewModel[value] }}
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-list-tile-content>
                        </v-list-tile>
                      </v-list>
                    </v-card-text>
                  </v-card>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-layout>
          </v-container>
        </v-card>
        <template>
          <v-btn color="primary" class="mb-2" @click="editItem">EDIT</v-btn>
        </template>
        <v-layout align-end justify-end>
          <v-speed-dial
            v-model="fab"
            bottom
            right
            direction="top"
            open-on-hover
            transition="slide-y-reverse-transition"
          >
            <!--        //TODO Revisit this area     
            <template v-slot:activator>
              <v-btn v-model="fab" color="primary" dark fab>
                <v-icon>account_circle</v-icon>
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <v-btn fab dark small color="secondary" @click="editItem">
              <v-icon>edit</v-icon>
            </v-btn> -->
            <!-- <v-btn
                    fab
                    dark
                    small
                    color="red"
                    @click="deleteItem"
                >
                    <v-icon>delete</v-icon>
                </v-btn> -->
          </v-speed-dial>
        </v-layout>
      </v-container>
    </v-card>
    <v-dialog v-model="deleteDialog" max-width="290">
      <v-card>
        <v-card-title class="headline"
          >Do you want to delete student profile?</v-card-title
        >
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="green darken-1"
            flat="flat"
            @click="deleteDialog = false"
          >
            Cancel
          </v-btn>
          <v-btn color="green darken-1" flat="flat" @click="remove()">
            Delete
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import Rules from "../rules";
import StudentForm from "./StudentForm";
import Utils from "../utils";
import dbStore from "../db/dbStore";
import firebase from "../firebase/firebase";

export default {
  name: "StudentView",
  components: {
    StudentForm
  },
  data: function() {
    return {
      id: this.$route.params.id,
      batchId: this.$route.params.batchId,
      deleteDialog: false,
      valid: true,
      isEditStudentForm: false,
      context: "view",
      progressBar: false,
      fab: false,
      dobPicker: false,
      preview: "",
      dropdowns: {},
      panel: [true, false, false, false],
      dropdownColumnMappings: {
        Gender: "gender",
        Location: "location",
        IdType: "id_type",
        MaritalStatus: "marital_status",
        Religion: "religion",
        Occupation: "occupation",
        Qualification: "qualification",
        Category: "category",
        Background: "background",
        AnnualIncome: "annual_income"
      },
      checkBoxColumns: ["HaveDisability", "IdConfirmedByPartner"],
      studentDetailSections: {
        personal: [
          "ProfileImage",
          "FirstName",
          "LastName",
          "Age",
          "Gender",
          "MothersName",
          "FathersName",
          "DateOfBirth"
        ],
        contact: ["Email", "Phone", "Address", "Location", "Pin"],
        batch: ["Batch", "DateOfEnrolment"],
        misc: [
          "DlNo",
          "Year",
          "Month",
          "IdType",
          "IdNo",
          "MaritalStatus",
          "Religion",
          "Occupation",
          "Qualification",
          "Category",
          "IdConfirmedByPartner",
          "Background",
          "AnnualIncome",
          "HaveDisability"
        ]
      },
      labelMappings: {
        FirstName: "First Name",
        LastName: "Last Name",
        DateOfBirth: "Date of Birth",
        MothersName: "Mother's Name",
        FathersName: "Father's Name",
        IdType: "ID Type",
        IdNo: "ID Number",
        DlNo: "DL Number",
        MaritalStatus: "Marital Status",
        DateOfEnrolment: "Date of Enrolment",
        IdConfirmedByPartner: "ID confirmed by partner",
        AnnualIncome: "Annual Income",
        HaveDisability: "Have Disability"
      },
      Status: ["Draft", "Saved", "Pending Approval", "Approved", "Rejected"],
      batchModel: {
        Id: "",
        Name: "",
        Center: "",
        StartDate: "",
        EndDate: "",
        NoOfStudents: "",
        Students: ""
      },
      editedModel: {
        Id: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Batch: "",
        DateOfBirth: "",
        Phone: "",
        Address: "",
        Year: "",
        Month: "",
        Age: "",
        Gender: "",
        Location: "",
        MothersName: "",
        FathersName: "",
        IdType: "",
        IdNo: "",
        MaritalStatus: "",
        Religion: "",
        Occupation: "",
        Qualification: "",
        Category: "",
        DateOfEnrolment: "",
        IdConfirmedByPartner: "",
        Pin: "",
        Background: "",
        AnnualIncome: "",
        HaveDisability: ""
      },
      studentModel: {
        Id: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Batch: "",
        DateOfEnrolment: ""
      },
      studentEmptyModel: {
        Id: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Batch: "",
        DateOfEnrolment: ""
      },
      studentProfileModel: {
        Id: "",
        DateOfBirth: "",
        Phone: "",
        Address: "",
        Year: "",
        Month: "",
        Age: "",
        Gender: "",
        Location: "",
        MothersName: "",
        FathersName: "",
        IdType: "",
        IdNo: "",
        MaritalStatus: "",
        Religion: "",
        Occupation: "",
        Qualification: "",
        Category: "",
        IdConfirmedByPartner: "",
        Pin: "",
        Background: "",
        AnnualIncome: "",
        HaveDisability: ""
      },
      studentProfileEmptyModel: {
        Id: "",
        DateOfBirth: "",
        Phone: "",
        Address: "",
        Year: "",
        Month: "",
        Age: "",
        Gender: "",
        Location: "",
        MothersName: "",
        FathersName: "",
        IdType: "",
        IdNo: "",
        MaritalStatus: "",
        Religion: "",
        Occupation: "",
        Qualification: "",
        Category: "",
        IdConfirmedByPartner: "",
        Pin: "",
        Background: "",
        AnnualIncome: "",
        HaveDisability: ""
      },
      model: {
        Id: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Batch: "",
        DateOfBirth: "",
        Phone: "",
        Address: "",
        Year: "",
        Month: "",
        Age: "",
        Gender: "",
        Location: "",
        MothersName: "",
        FathersName: "",
        IdType: "",
        IdNo: "",
        MaritalStatus: "",
        Religion: "",
        Occupation: "",
        Qualification: "",
        Category: "",
        DateOfEnrolment: "",
        IdConfirmedByPartner: "",
        Pin: "",
        Background: "",
        AnnualIncome: "",
        HaveDisability: ""
      },
      viewModel: {
        Id: "",
        FirstName: "",
        LastName: "",
        Email: "",
        Batch: "",
        DateOfBirth: "",
        Phone: "",
        Address: "",
        Year: "",
        Month: "",
        Age: "",
        Gender: "",
        Location: "",
        MothersName: "",
        FathersName: "",
        IdType: "",
        IdNo: "",
        MaritalStatus: "",
        Religion: "",
        Occupation: "",
        Qualification: "",
        Category: "",
        DateOfEnrolment: "",
        IdConfirmedByPartner: "",
        Pin: "",
        Background: "",
        AnnualIncome: "",
        HaveDisability: ""
      }
    };
  },
  watch: {},
  created() {
    this.getData();
  },

  computed: {
    getRules() {
      var rulesObject = Rules.getComponentRules("Student");
      //console.log(rulesObject)
      return rulesObject;
    }
  },
  methods: {
    getLabel(value) {
      if (this.labelMappings[value]) {
        value = this.labelMappings[value];
      }
      return value;
    },

    async updateStudentProperty(Id, json) {
      let response;
      try {
        //console.log(this.model)
        response = await dbStore.updateItemProperty(Id, json);
        if (response.isStateChanged) {
          this.getData();
        }
      } catch (err) {
        //throw.error(err);
        console.log("Error updating student : " + err);
      }
    },

    showButtons(status) {
      var currentStatus = this.studentModel.Status;
      var showButton = false;
      if (status == "Pending Approval") {
        if (currentStatus == "Saved") showButton = true;
      } else if (status == "Saved") {
        if (currentStatus == "Draft" || currentStatus == "Rejected")
          showButton = true;
      }
      return showButton;
    },

    saveApplication() {
      var json = { Status: "Saved" };
      this.updateStudentProperty(this.model.Id, json);
    },

    submitApplication() {
      var json = { Status: "Pending Approval" };
      this.updateStudentProperty(this.model.Id, json);
    },

    getSectionTitle(s) {
      return Utils.UpperCasefirst(s);
    },

    onFormCancel(value) {
      //console.log(value)
      if (value) {
        this.cancel();
      }
    },
    onFormSave(value) {
      if (value) {
        this.isEditStudentForm = false;
        this.getData();
      }
    },

    async getData() {
      this.progressBar = true;
      dbStore.setCollectionName("dropdowns");
      this.dropdowns = await dbStore.getItems();
      this.dropdowns = this.dropdowns[0];
      delete this.dropdowns.Id;
      dbStore.setCollectionName("students");
      this.studentModel = await dbStore.getItem(this.id);
      dbStore.setCollectionName("studentsprofile");
      this.studentProfileModel = await dbStore.getItem(this.id);
      Object.assign(this.model, this.studentModel);
      Object.assign(this.model, this.studentProfileModel);
      //till now student and studentprofile models are merged to model
      Object.assign(this.viewModel, this.model);
      Object.assign(this.editedModel, this.model);
      this.mapDropDowns(this.viewModel);
      this.mapDropDowns(this.editedModel);
      this.mapCheckboxes(this.viewModel);
      dbStore.setCollectionName("batches");
      this.batches = await dbStore.getItems();
      this.batchModel = Utils.getItemFromListWithId(
        this.batches,
        this.model.Batch
      );
      this.mapBatchInfo();
      if (this.viewModel.ProfileImage !== "")
        this.preview = await this.getProfileImageUrl(this.viewModel.ProfileImage);
      this.progressBar = false;
    },

    async getProfileImageUrl(path) {
      try {
        var storageReference = firebase.storage().ref();
        var profileImageRef = storageReference.child(path);
        var url = await profileImageRef.getDownloadURL();
        return url;
      } catch (err) {
        throw new Error(err);
      }
    },

    mapDropDowns(model) {
      var keys = Object.keys(this.dropdownColumnMappings);
      keys.forEach(element => {
        //console.log(element)
        var modelKey = model[element];
        //console.log(modelKey)
        var dropdownKey = this.dropdownColumnMappings[element];
        //console.log(dropdownKey)
        var itemArray = this.dropdowns[dropdownKey];
        var value = itemArray[modelKey];
        model[element] = value;
      });
    },

    mapBatchInfo() {
      this.viewModel.Batch = this.batchModel.Name;
    },

    mapCheckboxes(model) {
      //var keys = Object.keys(this.checkBoxColumns);
      this.checkBoxColumns.forEach(element => {
        //console.log(element)
        var modelValue = model[element];
        if (modelValue == true) model[element] = "Yes";
        else if (modelValue == false) model[element] = "No";
        else if (modelValue == "") model[element] = "N/A";
      });
    },

    editItem() {
      this.isEditStudentForm = true;
      this.context = "edit";
      this.editedModel = Object.assign({}, this.model);
    },

    deleteItem() {
      this.deleteDialog = true;
    },

    remove() {
      //this.deleteStudent(this.model);
      this.deleteDialog = false;
    },

    sendForApproval() {
      var json = { Status: "Pending Approval" };
      this.updateStudentProperty(this.id, json);
    },

    back() {
      if (this.context == "view") {
        this.$router.push({ name: "batch", params: { id: this.model.Batch } });
      } else if (this.context == "edit") {
        this.cancel();
      }
    },

    cancel() {
      this.isEditStudentForm = false;
      this.context = "view";
    }
  }
};
</script>
